import { render } from "./RestartQuizButton.vue?vue&type=template&id=0194fe0c"
import script from "./RestartQuizButton.vue?vue&type=script&lang=ts"
export * from "./RestartQuizButton.vue?vue&type=script&lang=ts"
script.render = render

export default script